import {
  Component, ComponentInterface, Host, State, Listen, h,
} from '@stencil/core';
import { parseJSONString } from '@pes-ui/components';
import { PBSStore } from './pes-testing-control-panel/store';

@Component({
  tag: 'pes-app-playground',
  styleUrl: 'pes-app-playground.scss',
})
export class PesAppPlayground implements ComponentInterface {
  // Lifehack to force render
  @State() updateCount = 0;

  @State() productIdToShow;

  showPanel = window.location.search.indexOf('hide-panel=true') === -1;

  constructor() {
    // Lifehack to force render
    PBSStore.on('set', () => this.updateCount++);
  }

  @Listen('ccDialogClosed')
  didCCDialogClosed(): void {
    this.productIdToShow = undefined;
  }

  get pesApp(): HTMLElement {
    return <slot name="pes-app" />;
  }

  private get app() {
    switch (PBSStore.get('appType')) {
      case 'commerceConnector':
        return (
          <div>
            {parseJSONString(PBSStore.get('products'), []).map((product) => (
                <div style={{ display: 'flex' }}>
                  <button onClick={() => (this.productIdToShow = product.commercialReference)}>
                    Show CC for {product.commercialReference}
                  </button>
                  -- Its price is <pes-cc-price productId={product.commercialReference} />
                </div>
            ))}
            <pes-cc-main
              host={PBSStore.get('host')}
              products={parseJSONString(PBSStore.get('products'), [])}
              additionalDistributors={parseJSONString(PBSStore.get('additionalDistributors'), [])}
              productIdToShow={this.productIdToShow}
              siteType={PBSStore.get('siteType')}
              localeCode={`${PBSStore.get('country')}/${PBSStore.get('language')}`}
            />
          </div>
        );
      case 'pesCatalog':
      default:
        return this.pesApp;
    }
  }

  render(): void {
    return (
      <Host style={{ display: 'block', 'padding-bottom': '40px' }}>
        {this.app}
        {this.showPanel && <pes-testing-control-panel />}
      </Host>
    );
  }
}
